import { PaymentCardShortInfo } from "@/features/payment/types";
import {
  InfoCard,
  InfoCardHeader,
  InfoCardValue,
  InfoCardMuted,
} from "@/components/ui/InfoCard";
import { CardOnFileStatusBadge } from "./CardOnFileStatusBadge";

interface PatientCardOnFileStatusProps {
  card: PaymentCardShortInfo | null;
}

export function PatientCardOnFileStatus({
  card,
}: PatientCardOnFileStatusProps) {
  const hasCard = !!card;

  return (
    <InfoCard>
      <InfoCardHeader
        title="Credit Card on File"
        right={<CardOnFileStatusBadge hasCard={hasCard} />}
      />

      <div className="px-5 py-4">
        {hasCard ? (
          <InfoCardValue>
            {card.brand} &bull;&bull;&bull;&bull; {card.last4}
          </InfoCardValue>
        ) : (
          <InfoCardMuted>No card on file for this patient.</InfoCardMuted>
        )}
      </div>
    </InfoCard>
  );
}
